var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"baseDisplayCkeditorContent",staticClass:"ck-content"},[_c('div',{staticClass:"d-block",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }